const columnHeaders = [
  'period',
  'type',
  'allowtopside',
  'activity',
  'slview',
  'allowentry',
  'allowtransfer',
];

export default columnHeaders;
